import apiLogin from "@app/api/apiLogin";
import type { LoginResponse, LoginRequest, AuthorizationRequest, AuthorizationResponse, GetUserResponse, User } from '../types/auth'
import { getUserResponseToUserMap } from "@auth/mappers/getUserResponseToUserMap";
import { removeAuthenticated, setAuthenticated } from "@auth/store";

const injected = apiLogin.injectEndpoints({
    endpoints: (build) => ({
        login: build.mutation<LoginResponse, LoginRequest>({
            query: (data) => ({ 
                url: '/auth/login', 
                method:'POST', 
                data
            }),
        }),

        logout: build.query<void, void>({
            query: () => ({ 
                url: '/auth/logout',
                method: 'GET'
            }),
            onQueryStarted: async(_, { dispatch, queryFulfilled }) => {
                await queryFulfilled;
                dispatch(removeAuthenticated());
            },
        }),

        getAuthorization: build.mutation<AuthorizationResponse, AuthorizationRequest>({
            query: (data) => ({ 
                url: '/user/dashboards/acceso', 
                method:'POST', 
                data
            }),
        }),
        
        getUser: build.query<User, void>({
            query: () => ({ 
                url: '/user/perfil', 
                method: 'GET'
            }), 
            transformResponse: (response: GetUserResponse) => 
                getUserResponseToUserMap(response), 
            onQueryStarted: async(_, { dispatch, queryFulfilled }) => { 
                const { data } = await queryFulfilled;
                dispatch(setAuthenticated(data))
            }
        })
    }),
})

injected.enhanceEndpoints({
    endpoints: {
        login: {
            invalidatesTags: ['USER']
        },

        getUser: {
            providesTags: ['USER']
        }
    }
})

export const { 
    useLoginMutation, 
    useGetAuthorizationMutation, 
    useGetUserQuery, 
    useLogoutQuery, 
    useLazyLogoutQuery, 
    useLazyGetUserQuery 
} = injected 